import { render, staticRenderFns } from "./goodResults.vue?vue&type=template&id=91e878ba&scoped=true&"
import script from "./goodResults.vue?vue&type=script&lang=js&"
export * from "./goodResults.vue?vue&type=script&lang=js&"
import style0 from "./goodResults.vue?vue&type=style&index=0&id=91e878ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e878ba",
  null
  
)

export default component.exports